import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthMiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  title,
  ...rest
}) => {
  const token = useSelector(({ auth }) => auth?.login?.token);

  const render = useCallback(
    props => {
      /* if user not logged in redirect to welcome page - protected route */
      if (isAuthProtected && !token) {
        return <Redirect to={{ pathname: '/welcome', state: { from: props.location } }} />;
      }

      return <Layout {...props} />;
    },
    [isAuthProtected, token]
  );

  return <Route {...rest} render={render} />;
};

AuthMiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  layout: PropTypes.any
};

export default AuthMiddleware;
